<template>
  <div class="LoadingLogo">
      
<img width="200" height="200" src="https://fontmeme.com/permalink/210419/dfd1e6030f57a8e561cf9c748aab2fb3.png" alt="netflix-font" border="0">
  
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

.LoadingLogo {
    display: flex;
    margin-top: 250px;
    justify-content: center;
    justify-items: center;
}

</style>